class MusterCardList extends HTMLElement {
  connectedCallback() {
    this.status = this.querySelector('[data-muster-status]');

    this.handleClick = this.onClick.bind(this);
    this.handleCartUpdate = () => this.sync();
    this.handlePageShow = (event) => {
      if (event.persisted) this.sync();
    };

    this.addEventListener('click', this.handleClick);
    document.addEventListener('cart:updated', this.handleCartUpdate);
    window.addEventListener('pageshow', this.handlePageShow);

    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.handleCartUpdate);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  get root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  get sectionsToRequest() {
    return 'mini-cart,cart-icon-bubble';
  }

  getIds(button) {
    return (button.dataset.variantIds || '').split(',').filter(Boolean);
  }

  // Gleicht alle Buttons mit dem Warenkorb ab, in beide Richtungen.
  // Eine Box gilt als hinzugefügt, wenn alle ihre Muster im Warenkorb liegen.
  // Wird beim Laden und bei jedem cart:updated aufgerufen.
  async sync() {
    const token = (this.syncToken = Symbol('sync'));

    try {
      const response = await fetch(`${this.root}cart.js`);
      const cart = await response.json();

      if (this.syncToken !== token) return;

      const inCart = new Set(cart.items.map((item) => String(item.variant_id)));

      this.querySelectorAll('[data-muster-add]').forEach((button) => {
        if (button.dataset.busy === 'true') return;

        const ids = this.getIds(button);
        if (ids.length && ids.every((id) => inCart.has(id))) {
          this.setAdded(button);
        } else {
          this.reset(button);
        }
      });
    } catch (error) {
    }
  }

  onClick(event) {
    const button = event.target.closest('[data-muster-add]');
    if (button) this.add(button);
  }

  async add(button) {
    if (button.dataset.busy === 'true' || button.disabled) return;

    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    this.announce('');

    try {
      const cartResponse = await fetch(`${this.root}cart.js`);
      const cart = await cartResponse.json();
      const inCart = new Set(cart.items.map((item) => String(item.variant_id)));

      const items = this.getIds(button)
        .filter((id) => !inCart.has(id))
        .map((id) => ({
          id: Number(id),
          quantity: 1,
          properties: { _muster: 'true', _musterbox: button.dataset.boxName || '' }
        }));

      if (!items.length) {
        this.setAdded(button);
        this.announce('Alle Muster dieser Box liegen bereits im Warenkorb.');
        return;
      }

      const response = await fetch(`${this.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          sections: this.sectionsToRequest,
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);

      this.setAdded(button);
      this.announce('Musterbox liegt im Warenkorb.');
      this.refreshCart(data);
    } catch (error) {
        this.announce(error.message || 'Die Musterbox wurde nicht hinzugefügt. Lade die Seite neu.', true);
    } finally {
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
    }
  }

  setAdded(button) {
    button.classList.add('is-added');
    button.disabled = true;
    this.setLabel(button, button.dataset.labelAdded);
  }

  reset(button) {
    const soldout = button.dataset.soldout === 'true';

    button.classList.remove('is-added');
    button.disabled = soldout;
    this.setLabel(button, soldout ? button.dataset.labelSoldout : button.dataset.labelDefault);
  }

  setLabel(button, text) {
    const label = button.querySelector('[data-muster-label]');
    if (label) label.textContent = text;
  }

  announce(message, isError = false) {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.toggleAttribute('data-error', isError);
  }

  refreshCart(data) {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart || !data.sections) return;

    if (this.dataset.openDrawer === 'true') {
      miniCart.renderContents(data);
      return;
    }

    miniCart.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = data.sections[section.id];

      if (target && html) {
        target.innerHTML = miniCart.getSectionInnerHTML(html, section.selector);
      }
    });
  }
}

customElements.define('muster-card-list', MusterCardList);
